export default __webpack_public_path__ + "a7f25154ac6a7140fb03d075f8ee4a26.png";